import React from 'react';
import { MailCheck, TriangleAlert } from 'lucide-react';
import InlineNotice from '@ajat/design-system/InlineNotice';
import Hyperlink from '@ajat/design-system/Hyperlink';
import { ComponentPage, DemoCard } from '../../shared';

export const meta = {
  component: InlineNotice,
  componentName: 'InlineNotice',
  title: 'Inline Notice',
  group: 'Data display',
  importPath: '@ajat/design-system/InlineNotice',
  description:
    'A tinted note inside the page flow — not a toast (that is Notification) and not a dialog (Popup): a demo-mode hint, "this order can no longer be edited", "we mailed you a link". The tone colours the icon and title; the text stays readable gray-10.',
  props: [
    ['variant', "'neutral' | 'success' | 'warning' | 'error' | 'info'", "'neutral'", 'Colour pair'],
    ['icon', 'node', '—', 'Leading icon, 20px'],
    ['title', 'node', '—', 'H6 line above the text'],
    ['children', 'node', '—', 'The note'],
    ['action', 'node', '—', 'A link or button under the text'],
    ['bordered', 'bool', 'false', '1px border in the tone colour'],
    ['size', "'s' | 'm'", "'m'", 'Padding: medium-s, or small-l / medium-s'],
    ['textVariant', "'body-sm' | 'body'", "'body-sm'", 'Running text size'],
    ['tone', "'accent' | 'text'", "'accent'", 'accent: tone on icon + title, gray-10 text · text: the running text in the tone colour too (the order confirmation box)'],
    ['role', 'string', '—', "ARIA role — 'status' for a live note, 'alert' for an error"],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'A pending request',
      code: `import InlineNotice from '@ajat/design-system/InlineNotice';

<InlineNotice icon={<MailCheck size={20} />} title="Radering begärd" role="status"
  action={<Hyperlink variant="small" inline href="#">Skicka igen</Hyperlink>}>
  Vi har mejlat en länk till kim@example.se.
</InlineNotice>`,
    },
  ],
};

export default function InlineNoticePage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Variants">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-ui-small-l)', maxWidth: 480 }}>
          <InlineNotice><strong>Demoläge</strong> Koden är 123456.</InlineNotice>
          <InlineNotice variant="success" title="Tack för din order">Vi har skickat en bekräftelse till din e-post.</InlineNotice>
          <InlineNotice variant="warning" bordered icon={<TriangleAlert size={20} />}>Ordern kan inte längre ändras.</InlineNotice>
          <InlineNotice variant="error" role="alert">Något gick fel. Försök igen.</InlineNotice>
          <InlineNotice
            icon={<MailCheck size={20} />}
            title="Radering begärd"
            action={<Hyperlink variant="small" inline href="#" onClick={(e) => e.preventDefault()}>Skicka igen</Hyperlink>}
          >
            Vi har mejlat en länk till kim@example.se.
          </InlineNotice>
        </div>
      </DemoCard>
    </ComponentPage>
  );
}
